import { render, staticRenderFns } from "./ScreenObstetricaDopplerPerfilCervical.vue?vue&type=template&id=31aac2d8&scoped=true&"
import script from "./ScreenObstetricaDopplerPerfilCervical.vue?vue&type=script&lang=js&"
export * from "./ScreenObstetricaDopplerPerfilCervical.vue?vue&type=script&lang=js&"
import style0 from "./ScreenObstetricaDopplerPerfilCervical.vue?vue&type=style&index=0&id=31aac2d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aac2d8",
  null
  
)

export default component.exports